import { ComponentPropsWithoutRef } from 'react';

export const TargetIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 64 64" fill="none">
      <path
        d="m61.84 28-12.8-8.76-2.84 4 9.16 6.28H34.48V8.64l6.28 9.16 4-2.84L36 2.16a5 5 0 0 0-8 0l-8.88 12.8 4 2.84 6.36-9.16v20.88H8.64l9.16-6.28-2.84-4L2.16 28a5 5 0 0 0 0 8l12.8 8.76 2.84-4-9.16-6.28h20.84v20.88l-6.24-9.16-4 2.84L28 61.84a5 5 0 0 0 8.24 0L45 49.04l-4-2.84-6.52 9.16V34.48h20.88l-9.16 6.28 2.84 4L61.84 36a5 5 0 0 0 0-8Z"
        fill="#000000"
      />
    </svg>
  );
};
